import moment from "moment";
import { metricKey } from "./metrics";

export const IN_ALARM = "In Alarm";
export const INSUFFICIENT_DATA = "Insufficient Data";
export const OK = "OK";
export const DISABLED = "Disabled";

export const IN_ALARM_COLOR = "rgba(245,86,86,0.68)";

export const GREATER = "Greater";
export const GREATER_EQUAL = `${GREATER}/Equal`;
export const LOWER = "Lower";
export const LOWER_EQUAL = `${LOWER}/Equal`;

export const DAYS_OF_WEEK = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export const IGNORE = "Ignore";
export const GOOD = "Good";
export const BAD = "Bad";

export const MISSING_DATA_TREATMENTS = [
  {
    name: IGNORE,
    description: "Use previous value",
  },
  {
    name: GOOD,
    description: "Does not breach threshold",
  },
  {
    name: BAD,
    description: "Breaches threshold",
  },
];

export const THRESHOLD_TYPES = [GREATER, GREATER_EQUAL, LOWER, LOWER_EQUAL];

export const DIGEST_DAILY = "Daily";
export const DIGEST_WEEKLY = "Weekly";
export const DIGEST_MONTHLY = "Monthly";

export const DIGEST_TYPES = [DIGEST_DAILY, DIGEST_WEEKLY, DIGEST_MONTHLY];

export const NOTIFY_IN_ALARM = "In Alarm";
export const NOTIFY_OK = "OK";
export const NOTIFY_BOTH = `${NOTIFY_IN_ALARM} and ${NOTIFY_OK}`;

export const NOTIFY_TYPES = [NOTIFY_IN_ALARM, NOTIFY_OK, NOTIFY_BOTH];

export const stateColor = (state) => {
  switch (state) {
    case IN_ALARM:
      return "red";
    case OK:
      return "green";
    case INSUFFICIENT_DATA:
    case DISABLED:
      return "gray";
  }
};

export const editableColor = (isEditable) => (isEditable ? "green" : "gray");

export const missingDataTreatmentDisplay = (name) => {
  return MISSING_DATA_TREATMENTS.find((it) => it.name === name)?.description;
};

export const conditionDisplay = (
  measurement,
  condition,
  threshold,
  expression,
) => {
  const toMeasure = expression ? "e1" : measurement;
  return `${toMeasure} ${
    condition === GREATER
      ? ">"
      : condition === GREATER_EQUAL
        ? ">="
        : condition === LOWER
          ? "<"
          : "<="
  } ${threshold}`;
};

export const alertConditionDisplay = (alert, metricsByKey) => {
  const firstMetric = alert.metrics[0];
  const key = metricKey(firstMetric);
  const metric = metricsByKey[key];
  if (!metric) {
    return undefined;
  }

  return conditionDisplay(
    metric.values[2],
    alert.condition,
    alert.threshold,
    alert.expression,
  );
};

export const alertDateConditionDisplay = (alert) => {
  return `${moment(alert.startDay).format("MMM DD")} - ${moment(
    alert.endDay,
  ).format("MMM DD")}`;
};

export const alertDayOfWeekConditionDisplay = (alert) => {
  const dow = alert.daysOfWeek ? new Set(alert.daysOfWeek) : undefined;

  if (!dow || dow.size === 7) {
    return "Every Day";
  }

  if (dow.size === 2 && dow.has("Saturday") && dow.has("Sunday")) {
    return "Weekends";
  }

  if (dow.size === 5 && !dow.has("Saturday") && !dow.has("Sunday")) {
    return "Weekdays";
  }

  return Array.from(dow)
    .map((it) => it.substring(0, 3))
    .join(",");
};

export const alertTimeConditionDisplay = (alert) => {
  return `${moment(alert.startTime).format("hh:mm A")} - ${moment(
    alert.endTime,
  ).format("hh:mm A")}`;
};

export const triggers = (condition, threshold, value) => {
  if (value > threshold) {
    return condition === GREATER || condition === GREATER_EQUAL;
  } else if (value === threshold) {
    return condition === GREATER_EQUAL || condition === LOWER_EQUAL;
  } else if (value < threshold) {
    return condition === LOWER_EQUAL || condition === LOWER;
  }
};

export const SELECT_METRIC = {
  id: 1,
  name: "Select metric",
};
export const SPECIFY_CONDITIONS = {
  id: SELECT_METRIC.id + 1,
  name: "Specify conditions",
};
export const CONFIGURE_ACTIONS = {
  id: SPECIFY_CONDITIONS.id + 1,
  name: "Configure actions",
};
export const ADD_NAME_AND_DESCRIPTION = {
  id: CONFIGURE_ACTIONS.id + 1,
  name: "Add name and description",
};

export const ADD_EDIT_STEPS = [
  SELECT_METRIC,
  SPECIFY_CONDITIONS,
  CONFIGURE_ACTIONS,
  ADD_NAME_AND_DESCRIPTION,
];
